import { eventGenderTypeIds, LeagueGenderTypeIds, LeagueGenderValues, drawEliminationTypeIds, ficFormats, tmsEventDrawTagIds } from './eventConstants';

export const getTypeById = (typeArr, id) => {
    return typeArr.find(type => type.id === parseInt(id));
};

export const getLabelByTypeId = (typeArr, id, ficFormatTypeId = null) => {
    if (id === drawEliminationTypeIds.FEED_IN_CONSOLATION) {
        if (ficFormatTypeId === ficFormats.FIC_16) {
            return `${typeArr.find(type => type.id === parseInt(id))?.label} To Rd 16`;
        }
        if (ficFormatTypeId === ficFormats.FIC_QF) {
            return `${typeArr.find(type => type.id === parseInt(id))?.label} To QF`;
        }
    }
    return typeArr.find(type => type.id === parseInt(id))?.label;
};

export const getDescriptionByTypeId = (typeArr, id) => {
    return typeArr.find(type => type.id === parseInt(id))?.description;
};

export const showTagValue = (tagId) => {
    return tagId && parseInt(tagId) !== tmsEventDrawTagIds.Retired && parseInt(tagId) !== tmsEventDrawTagIds.Withdrawn && parseInt(tagId) !== tmsEventDrawTagIds.Defaulted;
};

export const hasRetiredTag = (tagId) => {
    return parseInt(tagId) === tmsEventDrawTagIds.Retired || parseInt(tagId) === tmsEventDrawTagIds.Withdrawn || parseInt(tagId) === tmsEventDrawTagIds.Defaulted;
};

export const getValueByTypeId = (typeArr, id) => {
    return typeArr.find(type => type.id === parseInt(id))?.value;
};

export const getFilterGenderTypeId = (filterValue) => {
    if (filterValue === 'F') {
        return eventGenderTypeIds.FEMALE;
    }
    if (filterValue === 'M') {
        return eventGenderTypeIds.MALE;
    }
    return eventGenderTypeIds.ALL;
};

export const getGendersForLeagueSearch = (genderFilter) => {
    const { ALL, MALE, FEMALE, CO_ED } = LeagueGenderValues;
    const { MALE: maleId, FEMALE: femaleId, CO_ED: coedId } = LeagueGenderTypeIds;
    let genders;

    switch (genderFilter) {
        case ALL:
            genders = [maleId, femaleId, coedId];
            break;
        case MALE:
            genders = [maleId];
            break;
        case FEMALE:
            genders = [femaleId];
            break;
        case CO_ED:
            genders = [coedId];
            break;
        default:
            genders = [maleId, femaleId, coedId];
    }
    return genders;
};

export const LeagueTypeIds = {
    ADULT_TEAM_TENNIS: 1,
    JUNIOR_TEAM_TENNIS: 3,
    CLUB_TENNIS: 4,
    OTHER_TENNIS: 5,
    ADULT_TEAM_PICKLEBALL: 6,
    JUNIOR_TEAM_PICKLEBALL: 7,
    CLUB_TEAM_PICKLEBALL: 8,
    OTHER_PICKLEBALL: 9,
    CLUB_JUNIOR_TEAM_TENNIS: 10,
    CLUB_JUNIOR_TEAM_PICKLEBALL: 11,
};

export const AdTypes = {
    STICKY: 'sticky',
    LEADERBOARD_ONE: 'leaderboard_one',
    LEADERBOARD_TWO: 'leaderboard_two',
    RECTANGLE_ONE: 'rectangle_one',
    RECTANGLE_TWO: 'rectangle_two',
    RECTANGLE_THREE: 'rectangle_three',
    SKYSCRAPER_LEFT: 'skyscraper_left',
    SKYSCRAPER_RIGHT: 'skyscraper_right',
    WIDE_LEADERBOARD_ONE: 'wide_leaderboard_one',
    WIDE_LEADERBOARD_TWO: 'wide_leaderboard_two',
};
